import type { Role } from '@/types';

/** Stable role identifier — mirrors ApplicableRolesField fallback logic */
export function getRoleId(role: Role, index: number): string {
  return role.id ?? `role-${index}-${role.name}`;
}

function getApplicableRoles(
  roles: Role[],
  applicableRoleIds: string[] | null | undefined
): Role[] {
  const ids = applicableRoleIds ?? null;
  if (ids === null) return roles;
  return roles.filter((r, i) => ids.includes(getRoleId(r, i)));
}

export function hasAnyHalfDayRoles(
  roles: Role[],
  applicableRoleIds: string[] | null | undefined
): boolean {
  return getApplicableRoles(roles, applicableRoleIds)
    .some(r => r.billingStructure === 'day_rate' && r.allowHalfDay);
}

export function allApplicableRolesAreDayRate(
  roles: Role[],
  applicableRoleIds: string[] | null | undefined
): boolean {
  const applicable = getApplicableRoles(roles, applicableRoleIds);
  return applicable.length > 0 && applicable.every(r => r.billingStructure === 'day_rate');
}

export function hasAnyDayRateRoles(
  roles: Role[],
  applicableRoleIds: string[] | null | undefined
): boolean {
  return getApplicableRoles(roles, applicableRoleIds)
    .some(r => r.billingStructure === 'day_rate');
}
